export default "__VITE_ASSET__CHP1Zzo8__"